
import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import "./Carouselfp.css";

const Carosuelfp = ({ data, title, onSelect, autoPlay, autoPlayTime }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = useCallback(() => {
    if (data.length > 0) {
      setCurrentIndex((prevIndex) => (prevIndex + 3) % data.length);
    }
  }, [data]);

  const handlePrev = () => {
    if (data.length > 0) {
      setCurrentIndex((prevIndex) => (prevIndex - 3 + data.length) % data.length);
    }
  };

  const goToSlide = (index) => setCurrentIndex(index);

  const handleItemClick = (index) => {
    if (onSelect && typeof onSelect === "function") {
      onSelect(data[index]);
    }
  };

  useEffect(() => {
    if (autoPlay && data.length > 1) {
      const interval = setInterval(handleNext, autoPlayTime);
      return () => clearInterval(interval);
    }
  }, [autoPlay, autoPlayTime, handleNext, data.length]);

  const getVisibleItems = () => {
    if (data.length === 0) return [];
    const items = Array.from({ length: 3 }, (_, i) => data[(currentIndex + i) % data.length]);
    console.log("Visible Items:", items); // Debugging
    return items;
  };

  if (!data || data.length === 0) {
    return <div className="carousel"><p>No items available</p></div>;
  }

  return (
    <div className="carouselfp">
      <h3>{title}</h3>
      <div className="carousel-containerfp">
        <button onClick={handlePrev} className="carousel-buttonfp prevfp" aria-label="Previous Slide">
          &#10094;
        </button>
        <div className="carousel-itemsfp">
          {getVisibleItems().map((item, index) => (
            <div
              key={item?.id || index}
              className="carousel-itemfp"
              onClick={() => handleItemClick((currentIndex + index) % data.length)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => { if (e.key === 'Enter') handleItemClick((currentIndex + index) % data.length); }}
            >
              <h4>{item?.label || "No Label Available"}</h4>
            </div>
          ))}
        </div>
        <button onClick={handleNext} className="carousel-buttonfp nextfp" aria-label="Next Slide">
          &#10095;
        </button>
      </div>
      <div className="carousel-indicatorsfp">
        {data.map((item, index) => (
          <span
            key={item?.id || index}
            className={`indicatorfp ${index === currentIndex ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => { if (e.key === 'Enter') goToSlide(index); }}
            aria-label={`Go to slide ${index + 1}`}
          ></span>
        ))}
      </div>
    </div>
  );
};

Carosuelfp.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  autoPlay: PropTypes.bool,
  autoPlayTime: PropTypes.number,
};

Carosuelfp.defaultProps = {
  data: [],
  autoPlay: false,
  autoPlayTime: 3000,
};

export default Carosuelfp;
